<template>
    <v-container class="pt-0 pb-5" v-if="inscriptionStore.id">
        <v-row>
            <v-col>
                <div class="pa-2 rounded elevation-1 bg-white">
                    <v-btn color="primary-dark" @click="$router.go(-1)" density="compact" variant="outlined">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Retour
                    </v-btn>
                    <div class="text-h6 mt-3 mb-4">Mettre en vente votre inscription </div>
                    <p>Vous vous apprêtez à mettre en vente votre inscription ainsi que les options/activités
                        et articles associés.</p>

                    <div>Parcours mis en vente : <b>{{ inscriptionStore.courseName }}</b></div>
                    <div v-if="inscriptionStore.listCommandesOptionsText != ''">Options/activités/Articles mis en vente
                        : <b>{{ inscriptionStore.listCommandesOptionsText
                        }}</b></div>
                    <p>Votre inscription sera mise en vente sur la bourse aux dossards. Dès
                        qu'un participant aura acheté votre inscription vous serez notifié par email et nous
                        procéderons au remboursement de votre inscription. Cette opération est irréversible.</p>
                    <p v-if="mainStore.module.has_limite_transfert_dossard">La bourse aux dossards est
                        disponible
                        jusqu'au {{
                            $moment(mainStore.module.metadatas.limite_transfert_dossard).format("DD/MM/YYYY") }}</p>

                    <div>Prix de votre inscription : <b>{{ inscriptionStore.sellable_price }}€</b></div>
                    <div>Frais de vente : <b>5€</b></div>
                    <div>Somme qui vous sera remboursée : <b>{{ inscriptionStore.refundable_price }}€</b></div>
                    <v-separator></v-separator>

                    <v-form ref="formBourseDossard" v-model="formBourseDossardValid">
                        <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                            v-model="accepte_transfert">
                            <template v-slot:label>
                                Je reconnais que cette action est irréversible
                            </template>
                        </v-checkbox>
                        <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                            v-model="accepte_modalites">
                            <template v-slot:label>
                                J'accepte les modalités de vente de mon inscription sur la bourse aux dossards

                            </template>
                        </v-checkbox>

                        <v-btn v-if="(!accepte_transfert || !accepte_modalites)" color="primary-dark"
                            class="sm-fullwidth cursor_lock" variant="flat">
                            <v-icon icon="mdi-arrow-right-bold"></v-icon> Mettre en vente mon inscription
                            <v-tooltip activator="parent" location="top">Vous devez accepter les modalités de
                                vente de votre inscription sur la bourse aux dossards
                            </v-tooltip>
                        </v-btn>
                        <v-btn v-else class="sm-fullwidth" variant="flat" color="primary-dark"
                            @click="send_bourse_dossard_request"
                            :disabled="!accepte_transfert || !accepte_modalites"><v-icon
                                icon="mdi-arrow-right-bold"></v-icon>
                            Mettre en vente mon inscription
                        </v-btn>
                    </v-form>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useInscriptionStore } from "@/stores/inscriptionStore";

export default {
    name: 'RequestBourseDossardInscriptionView',
    data() {
        return {
            inscription: {},
            formBourseDossardValid: false,
            accepte_transfert: false,
            accepte_modalites: false
        };
    },
    computed: {
        ...mapStores(useMainStore, useInscriptionStore),
    },
    methods: {
        async send_bourse_dossard_request() {
            let request = await this.inscriptionStore.send_bourse_dossard_request();
            if (request) {
                this.mainStore.notification.send("Votre inscription a été mise en vente sur la bourse aux dossards", "success");
                this.$router.push({ name: "BourseDossards" });
            }
            else {
                this.mainStore.notification.send("Erreur lors de la mise en vente de votre inscription sur la bourse aux dossards", "error");
            }
        }
    },
    async created() {
        if (!this.mainStore.authUser.isLogged) {
            this.mainStore.notification.send("Vous devez être connecté pour mettre en vente votre inscription sur la bourse aux dossards", "error");
            this.$router.push({ name: "FicheCoureur" });
        }
        if (!this.mainStore.module.has_bourse_dossards) {
            this.mainStore.notification.send("La bourse aux dossards n'est pas disponible sur cet évènement", "error");
            this.$router.push({ name: "FicheCoureur" });
        }
        this.inscriptionStore.init();
        this.inscriptionStore.id = this.$route.params.id_inscription;
        let request = await this.inscriptionStore.get();
        if (!request) {
            this.mainStore.notification.send("Une erreur est survenue lors de la récupération de votre inscription", "error");
            this.$router.push({ name: "FicheCoureur" });
        }


    }
};
</script>

<style lang="scss" scoped></style>